import React from "react";
import { SVG, IconProps } from "../SVG";
export const SpotCopy = ({
    spotColor = "#C9DBFE",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
}: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40" {...props}>
        <g clipPath="url(#Spot=on,_Size=40_svg__a)">
            <path
                fill={spotColor}
                d="M34.4 39.076c-6.746 2.775-12.172-1.247-18.456-4.857C9.534 30.002-.79 31.317.048 22.86c.665-6.725 8.407-7.027 14.496-11.029C20.6 7.835 23.221 5.904 28.44 7.638c5.183 1.739 10.16 5.108 11.292 11.247 1.098 6.143-1.28 17.657-5.332 20.19Z"
            />
            <path
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
                d="M8.332 25H6.665a3.333 3.333 0 0 1-3.333-3.334v-15a3.333 3.333 0 0 1 3.333-3.333h15A3.333 3.333 0 0 1 25 6.666v1.667M18.333 15h15a3.333 3.333 0 0 1 3.333 3.334v15a3.333 3.333 0 0 1-3.333 3.333h-15a3.333 3.333 0 0 1-3.334-3.334v-15A3.333 3.333 0 0 1 18.332 15Z"
            />
        </g>
        <defs>
            <clipPath id="Spot=on,_Size=40_svg__a">
                <path fill="#fff" d="M0 0h40v40H0z" />
            </clipPath>
        </defs>
    </SVG>
);
SpotCopy.displayName = "SpotCopy";
